import { inject } from '@angular/core';
import { getLocalizedImages } from '@app/app.reducer';
import { AccessibilityService } from '@core/data-access/services/accessibility/accessibility.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { tap } from 'rxjs';
import { AccessibilityActions } from './accessibility.actions';
import { selectFontSizePercentage, selectIsHighContrastEnabled } from './accessibility.selectors';

export const toggleHighContrast$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), accessibilityService = inject(AccessibilityService)) =>
    actions$.pipe(
      ofType(AccessibilityActions.toggleHighContrast),
      concatLatestFrom(() => [store.select(selectIsHighContrastEnabled), store.select(getLocalizedImages)]),
      tap(([_, isHighContrastEnabled, localizedImages]) =>
        accessibilityService.setHighContrastTemplateAndBackgroundImage(
          isHighContrastEnabled,
          localizedImages.background
        )
      )
    ),
  { functional: true, dispatch: false }
);

export const setFontSizePercentage$ = createEffect(
  (actions$ = inject(Actions), accessibilityService = inject(AccessibilityService)) =>
    actions$.pipe(
      ofType(AccessibilityActions.setFontSizePercentage),
      tap(({ fontSizePercentage }) => accessibilityService.setFontSizePercentage(fontSizePercentage))
    ),
  { functional: true, dispatch: false }
);

export const resetAccessibilityState$ = createEffect(
  (actions$ = inject(Actions), store = inject(Store), accessibilityService = inject(AccessibilityService)) =>
    actions$.pipe(
      ofType(AccessibilityActions.resetReducer),
      concatLatestFrom(() => [
        store.select(selectIsHighContrastEnabled),
        store.select(selectFontSizePercentage),
        store.select(getLocalizedImages)
      ]),
      tap(([_, isHighContrastEnabled, fontSizePercentage, localizedImages]) => {
        accessibilityService.setHighContrastTemplateAndBackgroundImage(
          isHighContrastEnabled,
          localizedImages.background
        );
        accessibilityService.setFontSizePercentage(fontSizePercentage);
      })
    ),
  { functional: true, dispatch: false }
);
